<app-data-table title="Service Mappings"
                [columns]="columns"
                [fetchDataFn]="loadData"
                [exportDataFn]="exportData"
                [reloadEmitter]="reloadTable$"
                [enableGlobalSearch]="true"
                [loading]="loading"
                [globalFilterFields]="['service', 'service_mapped']"
                globalSearchPlaceholder="Search by services"
                defaultSortField="service"
                [exportable]="authService.hasPermission('service_mappings.service_mappings.export')">
</app-data-table>
